import * as e from "react";
import { forwardRef as r } from "react";
const c = r(function(t, l) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("g", { clipPath: "url(#prefix__clip0_8218_764)" }, /* @__PURE__ */ e.createElement("rect", { fill: "#089B80", height: 24, rx: 12, width: 24 }), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12 3L14.1244 9.37425H21L15.4374 13.314L17.5618 19.6882L12 15.7485L6.43818 19.6882L8.5626 13.3133L3 9.375H9.87558L12 3Z",
        fill: "#fff"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "prefix__clip0_8218_764" }, /* @__PURE__ */ e.createElement("rect", { fill: "#fff", height: 24, width: 24 })))
  );
});
export {
  c as StatusIconWon
};
